import { Form, Divider } from 'antd';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, Link } from 'react-router-dom';
import TrackClick from '../../components/Onetrack/TrackClick';
import TrackView from '../../components/Onetrack/TrackView';
import RegionSelect from '../../components/RegionSelect';
import CardLayout from '../../layouts/CardLayout';
import RoundButton from './Button';
import { useContact } from './context';
import styles from './index.module.less';
import ContactMeta from './Meta';

const ContactDPO: React.FC = () => {
  const intl = useIntl();
  const { values, category } = useContact();
  const history = useHistory();

  return (
    <TrackView tip="71.4.0.1.2158">
      <CardLayout
        loading={category.loading}
        meta={<ContactMeta />}
        title={<FormattedMessage id="Contact.Privacy.Team" />}
      >
        <Form
          className={styles.form}
          layout="vertical"
          initialValues={values}
          onFinish={(values) => {
            const params = new URLSearchParams(history.location.search);
            params.set('regionCode', values.regionCode);
            params.set('requestCategoryId', '5');
            params.set('requestTypeId', '45');
            history.push({ pathname: '/contact/suggestion', search: `?${params}` });
          }}
        >
          <div className={styles.legend}>
            <div className={styles.title}>
              <FormattedMessage id="Contact.DPO.Title" />
            </div>
            <div className={styles.subTitle}>
              <FormattedMessage id="Contact.DPO.Subtitle" />
            </div>
          </div>
          <Form.Item
            name="regionCode"
            label={<FormattedMessage id="Contact.Label.Region" />}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: 'Message.Region.Required',
                }),
              },
            ]}
          >
            <RegionSelect
              style={{ width: 435, maxWidth: '100%' }}
              placeholder={intl.formatMessage({
                id: 'Contact.Placeholder.Region',
              })}
            />
          </Form.Item>
          <Divider />
          <div className={styles.subTitle}>
            <FormattedMessage
              id="Contact.DPO.Tips"
              values={{
                contact: (
                  <Link to="/contact">
                    <FormattedMessage id="Contact.Privacy.Team" />
                  </Link>
                ),
                service: (
                  <Link to="/service">
                    <FormattedMessage id="Service" />
                  </Link>
                ),
              }}
            />
          </div>
          <Form.Item>
            <TrackClick tip="71.4.0.1.2159">
              <RoundButton
                className={styles.button}
                type="primary"
                htmlType="submit"
              >
                <FormattedMessage id="Contact.Button.Next" />
              </RoundButton>
            </TrackClick>
          </Form.Item>
        </Form>
      </CardLayout>
    </TrackView>
  );
};

export default ContactDPO;
